import React from 'react';
import Swal from "sweetalert2";
import { Field, Form } from 'react-final-form';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import renderCheckBoxField from '@/shared/components/form/CheckBox';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const LicensesList = (props) => {
    const submitNewLicense = (license) => {
        AdminInterface.instance.createLicense(license).then(() => {
            withReactContent(Swal).fire({
                title: "Success",
                html: "New license is created!",
            });
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: [error.response?.data?.detail.map((detail) => detail.msg)],
            });
        });
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>New License</CardTitle>
                </CardTitleWrap>
                <Form onSubmit={submitNewLicense}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Name</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="name" component="input" type="text" placeholder="Name" />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Link</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="link" component="input" type="text" placeholder="License Link" />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupField>
                                    <Field
                                        name="is_open_data"
                                        type="checkbox"
                                        component={renderCheckBoxField}
                                        label="Open Data" />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={form.reset}>
                                    Cancel
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>
            </CardBody>
        </Card>
    );
};

export default LicensesList;